module.exports = __webpack_public_path__ + "img/xxbg.599f12b4.png";